import {FeatureFlagService} from '@services/feature-flag.service';
import {Observable} from 'rxjs';
import {provideAppInitializer} from '@angular/core';

function initializeFeatureFlags(
	featureFlagService: FeatureFlagService
): () => Observable<any> {
	return () => featureFlagService.getFeatureFlags();
}

export const provideFeatureFlags = () => ({
	provide: provideAppInitializer,
	multi: true,
	useFactory: initializeFeatureFlags,
	deps: [FeatureFlagService]
});
